import { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text,{H3} from '@dbk/ui-text';
import { LoadingCircle } from '../../../components/common/loading';
import isEmpty from 'lodash/fp/isEmpty';
import additionalStyles from '../../data-exports/custom-transactions.styles';
import { PALETTE, RM_REGION_UK } from '../../../constants';
import { Currency } from '../../../../src/components/common/number';
import labelForPFid from '../../../utils/portfolio-number-aria-label';
import envConfig  from '../../../../db-env-build';
import { formatSortCode } from '../../../utils/format-sort-code';
import { EBANKINGWEBUK } from '../../../constants';


class SummaryCashAccountsMoreDetails extends PureComponent {

    componentDidMount() {
        this.props.cashAccountBookings();
    }

    componentWillUnmount() {
        this.props.setcashAccountData({});
        this.props.setbookings({});
        this.props.setLoading(false);
    }

    render(){
        const {
            i18n: { messages },
            cashAccounts: { cashAccountData, isLoading },
        } = this.props;
        const filterCashList = !isEmpty(cashAccountData) ? cashAccountData : [];
        const curBalSign = Math.sign(filterCashList.balance); 
        const curBalStyleColor = curBalSign === -1 ? additionalStyles.negativeDate : additionalStyles.date;
        const curBalDecimalStyle = curBalSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;
        const accInterestSign = Math.sign(filterCashList.accruedInterest)
        const accInterestStyleColor = accInterestSign === -1 ? additionalStyles.negativeDate : additionalStyles.date ;
        const accInterestDecimalStyle = accInterestSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;
        
        return(
            <div>
              {!isLoading ? <div className="row large-collapse">
                <div className="profile-container">
                  <div id="cash_account_header" className="cash_account_header">
                      <H3 className='header-main' tabIndex={0}>{filterCashList.name}</H3>
                  </div>
                  <div className='cash-more-details-container'>
                    <div className='cash-more-details-content'>
                      <div className='payment-details-section'>
                        <div tabIndex={0} className='detail-heading'>{messages['app.cashAccounts.label.accountDetails']}</div>
                        <div tabIndex={0} className='margin-top-20 margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.payment.psd2.cashAccount']}</Text></div>
                            {filterCashList.accountName && <div><Text size="large">{`${filterCashList.accountName} (${filterCashList.cashAccCurrency})`}</Text></div>}
                        </div>
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.iban']}</Text></div>
                            <div><Text size="large">{filterCashList.iban}</Text></div>
                        </div>
                        <div tabIndex={0} className='margin-bottom-15' aria-label={messages['app.common.pageTitle.portfolio']+": " + labelForPFid((filterCashList.pfId)) + " " + filterCashList.pfType}>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.portfolio']}</Text></div>
                            <div><Text size="large">{`${filterCashList.pfId} (${filterCashList.pfType})`}</Text></div>
                        </div>
                      {/*WMCE-47652-Displaying account number & sort code for UK's GBP accounts*/}
                      {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK ) && filterCashList.cashAccCurrency === 'GBP' && filterCashList?.accountNumber && (
                        <div tabIndex={0} className='margin-bottom-15'>
                          <div><Text size="large" secondary>{messages['app.payment.beneDetail.accountNumber']}</Text></div>
                          <div><Text size="large">{filterCashList.accountNumber}</Text></div>
                        </div>
                      )}
                      {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && filterCashList.cashAccCurrency === 'GBP' && filterCashList?.sortCode && (
                            <div tabIndex={0} className='margin-bottom-15'>
                                <div><Text size="large" secondary>{messages['app.payment.beneDetail.sortcodeLabel']}</Text></div>
                                <div><Text size="large">{formatSortCode(filterCashList.sortCode)}</Text></div>
                            </div>
                        )}
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.currentBalance']}</Text></div>
                            <Currency
                              signBeforeNumber={false}
                              decimalStyle={curBalDecimalStyle}
                              currencyStyle={additionalStyles.currencyStyleHeader}
                              currency={filterCashList.cashAccCurrency}
                              renderProps={{ style: curBalStyleColor, color: PALETTE.secondaryActive }} 
                              value= { (filterCashList.balance) ? filterCashList.balance: 0}
                            />
                        </div>
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.interestRate']}</Text></div>
                            <Currency
                              signBeforeNumber={false}
                              decimalStyle={accInterestDecimalStyle}
                              currencyStyle={additionalStyles.currencyStyleHeader}
                              currency={filterCashList.cashAccCurrency}
                              renderProps={{ style: accInterestStyleColor, color: PALETTE.secondaryActive }} 
                              value= {(filterCashList.accruedInterest) ? filterCashList.accruedInterest:0}
                            /> 
                        </div>
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.trade.label.toast.information']}</Text></div>
                            <div><Text size="large">{messages['app.cashAccounts.value.info']}</Text></div>
                        </div>
                      </div>

                      <div className='payment-details-section'>
                        <div tabIndex={0} className='detail-heading'>{messages['app.cashAccounts.label.onlinePaymentLimits']}</div>
                        <div tabIndex={0} className='margin-top-20 margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.dailyLimit']}</Text></div>
                            <div><Text size="large">{messages['app.cashAccounts.value.dailyLimit']}</Text></div>
                        </div>
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.weeklyLimit']}</Text></div>
                            <div><Text size="large">{messages['app.cashAccounts.value.weeklyLimit']}</Text></div>
                        </div>
                        <div tabIndex={0} className='margin-bottom-15'>
                            <div><Text size="large" secondary>{messages['app.cashAccounts.label.monthlyLimit']}</Text></div>
                            <div><Text size="large">{messages['app.cashAccounts.value.monthlyLimit']}</Text></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> :
              <div><LoadingCircle/></div>
              }
            </div>
        );
    }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    cashAccountBookings: { $call: 'cashAccounts.bookingList' },
    setbookings: { $set: 'cashAccounts.bookings' },
    setcashAccountData: { $set: 'cashAccounts.cashAccountData' },
    setLoading: { $set: 'cashAccounts.isLoading' },
    cashAccounts: {
      cashAccountData: true,
      isLoading: true,
    },
  },
})(SummaryCashAccountsMoreDetails);